import _regeneratorRuntime from "/Users/joe/Projects/onthewall-v2-leeungno/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
var _marked = /*#__PURE__*/ _regeneratorRuntime().mark(getMusic), _marked2 = /*#__PURE__*/ _regeneratorRuntime().mark(watchGetMusic), _marked3 = /*#__PURE__*/ _regeneratorRuntime().mark(globalSaga);
import { all, fork, put, call, takeEvery } from "redux-saga/effects";
import { actions } from "../reducers/music";
import { rsfDB } from "../lib/firebase"; // call은 동기, fork는 비동기 요청
function getMusic(action) { var id, musicData; return _regeneratorRuntime().wrap(function getMusic$(_context) { while (1)
    switch (_context.prev = _context.next) {
        case 0:
            id = action.id;
            _context.prev = 1;
            _context.next = 4;
            return call(rsfDB.getDocument, "Music/".concat(id));
        case 4:
            musicData = _context.sent;
            _context.next = 7;
            return put({ type: actions.GET_MUSIC_SUCCESS, data: musicData.data() });
        case 7:
            _context.next = 13;
            break;
        case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            _context.next = 13;
            return put({ type: actions.GET_MUSIC_FAILURE, error: _context.t0.message });
        case 13:
        case "end": return _context.stop();
    } }, _marked, null, [[1, 9]]); }
function watchGetMusic() { return _regeneratorRuntime().wrap(function watchGetMusic$(_context2) { while (1)
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return takeEvery(actions.GET_MUSIC_REQUEST, getMusic);
        case 2:
        case "end": return _context2.stop();
    } }, _marked2); }
export default function globalSaga() { return _regeneratorRuntime().wrap(function globalSaga$(_context3) { while (1)
    switch (_context3.prev = _context3.next) {
        case 0:
            _context3.next = 2;
            return all([fork(watchGetMusic)]);
        case 2:
        case "end": return _context3.stop();
    } }, _marked3); }
